import { render } from "./emailComponent.vue?vue&type=template&id=07a87802&scoped=true"
import script from "./emailComponent.vue?vue&type=script&lang=js"
export * from "./emailComponent.vue?vue&type=script&lang=js"

import "./emailComponent.vue?vue&type=style&index=0&id=07a87802&scoped=true&lang=css"
import "./emailComponent.vue?vue&type=style&index=1&id=07a87802&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a87802"]])

export default __exports__